import { apiSlice } from "../../app/api/apiSlice";

export const productKnowledgeApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getProductKnowledgeEvaluations: builder.query({
      query: (params) => ({
        url: "/api/v1/resources/evaluations/product_knowledge/",
        params,
      }),
      providesTags: ["ProductKnowledgeEvaluation"],
    }),
    getProducts: builder.query({
      query: (params) => ({
        url: "/api/v1/resources/products/",
        params,
      }),
      providesTags: ["Product"],
    }),
    getProduct: builder.query({
      query: (id) => `/api/v1/resources/products/${id}/`,
      providesTags: (result, error, id) => [{ type: "Product", id }],
    }),
    createProduct: builder.mutation({
      query: (data) => ({
        url: "/api/v1/resources/products/",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Product"],
    }),
    updateProduct: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/api/v1/resources/products/${id}/`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["Product"],
    }),
    deleteProduct: builder.mutation({
      query: (id) => ({
        url: `/api/v1/resources/products/${id}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["Product"],
    }),

    getQuizQuestions: builder.query({
      query: (params) => ({ 
        url: "/api/v1/resources/quiz/questions/",
        params
      }),
      providesTags: ["QuizQuestion"],
    }),
    getQuizQuestion: builder.query({
        query: (id) => `/api/v1/resources/quiz/questions/${id}/`,
        providesTags: (result, error, id) => [{ type: "QuizQuestion", id }],
    }),
    createQuizQuestion: builder.mutation({
      query: (data) => ({
        url: "/api/v1/resources/quiz/questions/",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["QuizQuestion"],
    }),
    updateQuizQuestion: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/api/v1/resources/quiz/questions/${id}/`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["QuizQuestion"],
    }),
    deleteQuizQuestion: builder.mutation({
      query: (id) => ({
        url: `/api/v1/resources/quiz/questions/${id}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["QuizQuestion"],
    }),

    getQuizAttempts: builder.query({
      query: (params) => ({
        url: "/api/v1/resources/quiz/attempts/",
        params,
      }),
      providesTags: ["QuizAttempt"],
    }),
    
    getQuizAttempt: builder.query({
      query: (id) => `/api/v1/resources/quiz/attempts/${id}/`,
      providesTags: ["QuizAttempt"],
    }),

    generateQuizSet: builder.query({
        query: (params) => ({
            url: "/api/v1/resources/quiz/questions/generate_set/",
            params
        }),
        keepUnusedDataFor: 0,
    }),

    createQuizAttempt: builder.mutation({
        query: (data) => ({
            url: "/api/v1/resources/quiz/attempts/",
            method: "POST",
            body: data
        }),
        invalidatesTags: ["QuizAttempt"]
    }),

    getQuizStats: builder.query({
        query: (userId) => ({
            url: "/api/v1/resources/quiz/attempts/stats/",
            params: userId ? { user_id: userId } : undefined,
        }),
        providesTags: ["QuizAttempt"],
    }),

    getPKEStats: builder.query({
        query: (userId) => ({
            url: "/api/v1/resources/evaluations/product_knowledge/stats/",
            params: userId ? { user_id: userId } : undefined,
        }),
        providesTags: ["ProductKnowledgeEvaluation"],
    }),
  }),
});

export const {
  useGetProductKnowledgeEvaluationsQuery,
  useGetProductsQuery,
  useGetProductQuery,
  useCreateProductMutation,
  useUpdateProductMutation,
  useDeleteProductMutation,
  useGetQuizQuestionsQuery,
  useGetQuizQuestionQuery,
  useCreateQuizQuestionMutation,
  useUpdateQuizQuestionMutation,
  useDeleteQuizQuestionMutation,
  useGetQuizAttemptsQuery,
  useGetQuizAttemptQuery,
  useGenerateQuizSetQuery,
  useCreateQuizAttemptMutation,
  useGetQuizStatsQuery,
  useGetPKEStatsQuery,
} = productKnowledgeApiSlice;
